import { STORED_TABS_KEY, TAB_ID_KEY, TAB_TTL_MS } from './constants';

const hasLiveTabs = (): boolean => {
	try {
		const tabs: Record<string, number> = JSON.parse(
			localStorage.getItem(STORED_TABS_KEY) ?? '{}'
		);
		const now = Date.now();

		return Object.values(tabs).some((lastSeen) => now - lastSeen < TAB_TTL_MS);
	} catch {
		return false;
	}
};

const decideSessionEnded = (): boolean => {
	try {
		return !sessionStorage.getItem(TAB_ID_KEY) && !hasLiveTabs();
	} catch {
		return false;
	}
};

const previousSessionEnded = decideSessionEnded();

export const hasPreviousSessionEnded = (): boolean => previousSessionEnded;
